module.exports = __webpack_public_path__ + "static/img/医疗卡片1_初始状态@2x.24a943bf.png";